import {
  breakpointsLg,
  breakpointsMd,
  breakpointsSm,
  breakpointsXl,
  breakpointsXs,
  elevation,
  radiusBorderRadius,
  spacingBase,
  zIndex,
} from '@mds/tokens';
import type { Shadows } from '@mui/material';

export const themeZIndex = {
  mobileStepper: zIndex.mobileStepper,
  fab: zIndex.fab,
  speedDial: zIndex.speedDial,
  toolbar: zIndex.toolbar,
  appSidebar: zIndex.appSidebar,
  accessoryDrawer: zIndex.accessoryDrawer,
  appBar: zIndex.appBar,
  drawer: zIndex.drawer,
  modal: zIndex.modal,
  snackbar: zIndex.snackbar,
  tooltip: zIndex.tooltip,
} as const;

export const themeShadows = [
  elevation.elevation0,
  elevation.elevation1,
  elevation.elevation2,
  elevation.elevation3,
  elevation.elevation4,
  elevation.elevation5,
  elevation.elevation6,
  elevation.elevation7,
  elevation.elevation8,
  elevation.elevation9,
  elevation.elevation10,
  elevation.elevation11,
  elevation.elevation12,
  elevation.elevation13,
  elevation.elevation14,
  elevation.elevation15,
  elevation.elevation16,
  elevation.elevation17,
  elevation.elevation18,
  elevation.elevation19,
  elevation.elevation20,
  elevation.elevation21,
  elevation.elevation22,
  elevation.elevation23,
  elevation.elevation23,
] as Shadows;

export const themeBreakpoints = {
  values: {
    xs: Number.parseInt(breakpointsXs, 10),
    sm: Number.parseInt(breakpointsSm, 10),
    md: Number.parseInt(breakpointsMd, 10),
    lg: Number.parseInt(breakpointsLg, 10),
    xl: Number.parseInt(breakpointsXl, 10),
  },
};

export const themeShape = {
  borderRadius: Number.parseInt(radiusBorderRadius, 10),
  borderWidth: 1,
};

export const themeSpacing = Number.parseInt(spacingBase, 10);
